/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// react-router components
import { useLocation, Link, useNavigate } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import Breadcrumbs from "examples/Breadcrumbs";

// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarMobileMenu,
} from "examples/Navbars/DashboardNavbar/styles";

// Material Dashboard 2 React context
import { useMaterialUIController, setMiniSidenav } from "context";
import MDTypography from "components/MDTypography";
import { Divider, MenuItem } from "@mui/material";
import ChangePasswordDialog from "pages/reset-password/ResetPassword";
import { useAuth } from "pages/Auth/AuthContext";
function DashboardNavbar({ absolute, light, isMini }) {
  const navigate = useNavigate();
  const { logoutUser } = useAuth();
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav, fixedNavbar, darkMode } = controller;
  const route = useLocation().pathname.split("/").slice(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openChangePassword, setOpenChangePassword] = useState(false);

  const authData = JSON.parse(localStorage.getItem("pt") || "{}");
  const role = authData?.role;
  const name = authData?.name;
  const employeeId = authData?.employeeId;

  const handleOpenAccountMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  // const handleLogout = () => {
  //   handleCloseAccountMenu();
  //   localStorage.removeItem("p");
  //   navigate("/auth/sign-in");
  // };

  const handleCloseAccountMenu = () => {
    setAnchorEl(null);
  };

  const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);

  // Styles for the navbar icons
  const iconsStyle = ({ palette: { dark, white, text } }) => ({
    color: light || darkMode ? white.main : text.main,
  });

  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "transparent",
          boxShadow: "none",
        }}
      >
        {/* <Toolbar sx={(theme) => navbarContainer(theme)}> */}
        <Toolbar
          variant="dense"
          disableGutters
          sx={(theme) => navbarContainer(theme)}
        >
          <MDBox
            color="inherit"
            mb={{ xs: 1, md: 0 }}
            sx={(theme) => navbarRow(theme, { isMini })}
          >
            {/* <Breadcrumbs
            icon="home"
            title={route[route.length - 1]}
            route={route}
            light={light}
          /> */}
          </MDBox>
          {isMini ? null : (
            <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
              <MDBox color={light ? "white" : "inherit"}>
                <MDBox display="flex" alignItems="center" gap={1}>
                  <MDBox display="flex" flexDirection="column" lineHeight={1}>
                    <MDTypography
                      variant="body2"
                      fontWeight="medium"
                      sx={(theme) => ({
                        color: light
                          ? theme.palette.white.main
                          : theme.palette.text.main,
                      })}
                    >
                      {name} ({employeeId})
                    </MDTypography>
                    <MDTypography
                      variant="body2"
                      fontWeight="small"
                      sx={(theme) => ({
                        color: light
                          ? theme.palette.white.main
                          : theme.palette.text.secondary,
                      })}
                    >
                      {role}
                    </MDTypography>
                  </MDBox>

                  <IconButton
                    sx={navbarIconButton}
                    size="small"
                    disableRipple
                    onClick={handleOpenAccountMenu}
                  >
                    <Icon sx={iconsStyle}>more_vert</Icon>
                  </IconButton>
                </MDBox>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleCloseAccountMenu}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  {/* Logout */}
                  <MenuItem onClick={logoutUser} sx={{ color: "text.main" }}>
                    <Icon fontSize="small" sx={{ mr: 1 }}>
                      logout
                    </Icon>
                    Logout
                  </MenuItem>
                </Menu>

                <IconButton
                  size="small"
                  disableRipple
                  color="inherit"
                  sx={navbarMobileMenu}
                  onClick={handleMiniSidenav}
                >
                  <Icon sx={iconsStyle} fontSize="medium">
                    {miniSidenav ? "menu_open" : "menu"}
                  </Icon>
                </IconButton>
              </MDBox>
            </MDBox>
          )}
        </Toolbar>
      </AppBar>

      <ChangePasswordDialog
        open={openChangePassword}
        handleClose={() => setOpenChangePassword(false)}
      />
    </>
  );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
